var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3104 2.82238C15.5187 3.03063 15.5187 3.36826 15.3104 3.57651L6.5738 12.3131C6.18328 12.7037 5.55011 12.7037 5.15959 12.3131L0.689627 7.84318C0.481379 7.63493 0.48138 7.29729 0.689628 7.08905C0.897876 6.8808 1.23551 6.8808 1.44376 7.08905L5.15959 10.8049C5.55011 11.1954 6.18328 11.1954 6.5738 10.8049L14.5563 2.82238C14.7645 2.61413 15.1022 2.61413 15.3104 2.82238Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.c0ff30f5edfdc5386d346052ca01f399.svg";
export { ForwardRef as ReactComponent };